import React from "react";
import {Auth} from "@aws-amplify/auth";

export const SignInButtons = ({setLoading, env}) => (
    <React.Fragment>
        <button className="GoogleButton"
                onClick={() => {setLoading(); Auth.federatedSignIn({
                    provider: 'Google',
                    customState: `${env}`
                })}}/>
    </React.Fragment>
);

export const SignOutButtons = () => (
    <React.Fragment>
        <button onClick={() => Auth.signOut()}>Sign Out</button>
    </React.Fragment>
);